import { useEffect } from 'react';

if (typeof window !== 'undefined') {
  const originalConsoleError = console.error;

  console.error = (...args) => {
    const isTrinityError = args[0]?.toString().includes("Cannot find player iframe for playerId: player-2900020929");
    if (isTrinityError) {
      console.warn("[Trinity] Silenced expected player iframe error.");
      return;
    }

    // Otherwise, call original error
    originalConsoleError(...args);
  };
}


const TrinityAudioPlayer = ({ selector = '.my-audio-content', langKey = 'en' }) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const isPrinting = window.matchMedia?.('print').matches;
    if (isPrinting) {
      console.warn('[Trinity] Skipping injection during print');
      return;
    }

    let observer;
    let timeoutId;

    const removeOldTrinity = () => {
      const oldScript = document.getElementById('trinity-script');
      if (oldScript) {
        oldScript.remove();
        console.log('[Trinity] Removed old script');
      }

      document.querySelectorAll('iframe').forEach((iframe) => {
        if (iframe.src.includes('trinitymedia.ai')) {
          iframe.remove();
          console.log('[Trinity] Removed old iframe');
        }
      });
    };

    const injectNewTrinity = () => {
      const container = document.querySelector(`${selector} p`) || document.querySelector(selector);
      const textContent = container?.textContent?.trim();

      if (!container || !textContent) {
        console.warn('[Trinity] No valid content. Skipping injection.');
        return;
      }

      const encodedSelector = encodeURIComponent(btoa(selector));

      requestAnimationFrame(() => {
        setTimeout(() => {
          try {
            const script = document.createElement('script');
            script.id = 'trinity-script';
            script.setAttribute('data-player-id', 'player-2900020929');
            script.src = `https://trinitymedia.ai/player/trinity/2900020929/?pageURL=${encodeURIComponent(
              window.location.href
            )}&documentLoadType=onSelectorVisible&documentLoadTypeSelector=${encodedSelector}&textSelector=${encodeURIComponent(
              btoa(selector)
            )}`;
            script.async = true;
            document.body.appendChild(script);
            console.log('[Trinity] Script injected');
          } catch (err) {
            console.warn('[Trinity] Script injection failed:', err);
          }
        }, 300); // delay after requestAnimationFrame
      });
    
    };

    const styleIframeWhenReady = () => {
      observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (
              node.nodeType === 1 &&
              node.tagName === 'IFRAME' &&
              node.src.includes('trinitymedia.ai')
            ) {
              node.classList.add('trinity-iframe');
              Object.assign(node.style, {
                maxWidth: '83.44%',
                zIndex: '999',
                position: 'fixed',
                background: '#fff',
                left: '16.66%',
                bottom: '0',
                marginBottom: '0',
                border: 'none',
                borderRadius: '12px',
                width: '100%',
              });
              console.log('[Trinity] Player iframe styled.');
            }
          });
        });
      });

      const target = document.querySelector(selector);
      if (target) {
        observer.observe(target, { childList: true, subtree: true });
      }
    };

    // Full logic with delay to wait for tab render
    timeoutId = setTimeout(() => {
      removeOldTrinity();
      injectNewTrinity();
      styleIframeWhenReady();
    }, 300); // wait for content render after tab switch

    return () => {
      clearTimeout(timeoutId);
      if (observer) observer.disconnect();
    };
  }, [selector, langKey]);

  return null;
};

export default TrinityAudioPlayer;
